import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6.5 py-11" }
const _hoisted_2 = { class: "flex justify-between mb-7" }
const _hoisted_3 = { class: "flex justify-start" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "relative h-42 w-288 me-3" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "absolute end-2 top-2.5" }
const _hoisted_8 = { class: "flex items-center justify-start me-8 ms-8" }
const _hoisted_9 = { class: "font-normal text-base pe-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center text-darkText text-lg px-4 py-8 font-bold" }, "No items to show")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_DateRange = _resolveComponent("DateRange")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: _ctx.$t('placeholders.orders_filter'),
              class: "h-42 absolute py-3.5 ps-3.5 pe-9 top-0 start-0 w-full h-full block appearance-none bg-transparent",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event))
            }, null, 8, _hoisted_6), [
              [_vModelText, _ctx.searchValue]
            ]),
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_BaseIcon, { name: "search" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('drivers.date')), 1),
          _createVNode(_component_DateRange)
        ])
      ])
    ]),
    _hoisted_10
  ]))
}